import { useState } from 'react';
import { AddUserAccountDto } from '../../../../../../types';
import UserBCFields from './userBCFields';
import CarriersSelect from '../../../carriersSelect';

interface Props {
  formData: AddUserAccountDto;
  setFormData: any;
  setShowUserDetailForm: any;
  setShowUserSettingForm: any;
  setShowUserCreation: any;
  onSave: any;
}
function UserSettingContainer({
  formData,
  setFormData,
  setShowUserDetailForm,
  setShowUserSettingForm,
  setShowUserCreation,
  onSave,
}: Props) {
  const [validating, setValidating] = useState(false);
  function handleBack() {
    setShowUserDetailForm(true);
    setShowUserSettingForm(false);
  }
  function handleNext() {
    if (formData.is_business_central) {
      setValidating(true);
      if (formData.bc_username !== '') {
        handleSubmit();
      }
    } else {
      handleSubmit();
    }
  }
  function handleSubmit() {
    onSave();
    setShowUserSettingForm(false);
    setShowUserCreation(true);
  }
  return (
    <div
      className='row mt-4'
      id='optional_details'
    >
      <div className='col-sm-12 col-md-3'></div>
      <div className='col-sm-12 col-md-12'>
        <div className='ubbe-card'>
          <div className='ubbe-card-header'>
            <h5 className='ps-3 mb-0 GlobalBoxHead'>Optional Settings</h5>
          </div>
          <div className='card-body pt-3 px-4 pb-5'>
            <div className='mb-3'>
              <div className='form-check'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  id='is_price_hide'
                  checked={formData.is_price_hide}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      is_price_hide: e.target.checked,
                    });
                  }}
                />
                <label
                  className='form-check-label globalInputLabel'
                  style={{ fontWeight: '300' }}
                  htmlFor='is_price_hide'
                >
                  Do you want the prices to be Hidden?
                </label>
              </div>
            </div>

            <div className='mb-3'>
              <div className='form-check'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  id='is_vendor'
                  checked={formData.is_vendor}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      is_vendor: e.target.checked,
                    });
                  }}
                />
                <label
                  className='form-check-label globalInputLabel'
                  style={{ fontWeight: '300' }}
                  htmlFor='is_vendor'
                >
                  Is the user a Vendor?
                </label>
              </div>
            </div>
            {formData.is_vendor && (
              <div id='carriers_div'>
                <div className='row mb-4'>
                  <div className='col-sm-12'>
                    <CarriersSelect
                      formData={formData}
                      setFormData={setFormData}
                      // userSetting={'userSetting'}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className='mb-3 '>
              <div className='form-check mt-3'>
                <input
                  className='form-check-input '
                  type='checkbox'
                  id='is_bc'
                  checked={formData.is_business_central}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      is_business_central: e.target.checked,
                    });
                  }}
                />
                <label
                  className='form-check-label globalInputLabel'
                  style={{ fontWeight: '300' }}
                  htmlFor='is_bc'
                >
                  Is the user a business central user or need access to the
                  connector?
                </label>
              </div>
            </div>
            {formData?.is_business_central && (
              <UserBCFields
                formData={formData}
                setFormData={setFormData}
                validating={validating}
              />
            )}
          </div>
        </div>
      </div>
      <div className='d-flex mt-4 justify-content-between align-items-center'>
        <div className=''>
          <button
            className='btn btn-ubbe-new-back d-flex gap-2'
            onClick={() => {
              handleBack();
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='15'
              height='8'
              viewBox='0 0 15 8'
              fill='none'
            >
              <path
                d='M3.03077 0.670207L0.176923 3.5735C0.123077 3.62828 0.0769229 3.69871 0.0461536 3.77697C0.0461536 3.7848 0.0461536 3.79262 0.0384613 3.80045C0.0153844 3.86305 -1.56239e-07 3.92566 -1.53161e-07 3.99609C-1.4632e-07 4.1526 0.0615383 4.30129 0.169231 4.41084L3.03077 7.32979C3.25385 7.55674 3.62308 7.55674 3.84615 7.32979C4.06923 7.10285 4.06923 6.72722 3.84615 6.50028L1.96154 4.58301L14.4231 4.58301C14.7385 4.58301 15 4.31694 15 3.99609C15 3.67524 14.7385 3.40917 14.4231 3.40917L1.96923 3.40917L3.84615 1.49972C3.96154 1.38234 4.01538 1.23365 4.01538 1.08496C4.01538 0.936277 3.96154 0.787591 3.84615 0.670207C3.62308 0.443265 3.26154 0.443265 3.03077 0.670207Z'
                fill='black'
              />
            </svg>
            Back
          </button>
        </div>
        <div className=''>
          <p
            className='btn btn-ubbe-new-blue mb-0'
            onClick={() => {
              handleNext();
            }}
          >
            Continue
          </p>
        </div>
      </div>
    </div>
  );
}

export default UserSettingContainer;
